export default function(array, index1, index2) {
  return Object.assign([], array, {
    [index1]: array[index2],
    [index2]: array[index1]
  })
}
